import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie';
import {checkprotectedroutes, setActivity } from '../../Global/Index'
import { ToastContainer, toast } from 'react-toastify';
import HeaderOuter from '../Nav Bar/HeaderOuter';
import LayoutShortcut from '../Layout Shortcut/Shortcut';
import BeatLoader from 'react-spinners/BeatLoader';
import { useTheme } from '@mui/material';
 
 
export default function TC() {
    const encoded_token = Cookies.get('token');
    const [isAuthorized, setIsAuthorized] = useState(null); // State to track authorization
    const [submitloader] = useState(false);
    const theme=useTheme();
    const override={
      // display: "block",
      margin: "0 auto",
      marginLeft: '.3vw'
    };
    
  
    useEffect(() => {
      const checkProtectedRoutes = async () => {
        setActivity('Term & Condition Page');
        if (!encoded_token) {
          window.location.href = '/';
          return;
        }
  
        const isProtected = await checkprotectedroutes();
        if (!isProtected) {
          toast.warn('You are not authorized to access this page. Please login again.');
          Cookies.remove('token'); // Remove the token from cookies
          // window.location.href = '/';
        } else {
          setIsAuthorized(true); // Set authorized state to true
        }
      };
  
      checkProtectedRoutes();
    }, [encoded_token]); // Add token as a dependency
  
 
 
    if (!isAuthorized) {
      return <div>
          
          <BeatLoader
                color="rgb(155,57,19)"
                loading={submitloader}
                cssOverride={override}
                size={8}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
      </div>; // Show a loading state while checking authorization
    }else{
    return (
      <>
        
        <ToastContainer />
        <HeaderOuter/>
        <div
          // style={{ marginTop: "10vh", marginBottom: "10vh" }}
          className="maincontainer"  style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main}}
        >
          {/* <div>{JSON.stringify(data)}</div> */}
          <h2>Terms and Conditions</h2>
          <div className="sunContainer" style={{ marginTop: "2vh", padding: "2vh" }}>
          <p>This Privacy Policy (“Policy”) explains our policy regarding the processing of your information which inter alia includes collection, use, disclosure and transfer of your information by India Shelter Finance Corporation Limited and/or its subsidiary (ies) and / or its associates and/or its affiliate(s) (collectively referred to as the “Company”), which operates the website (“Website”), the mobile and web applications and other allied services (“India Shelter Apps” or “Apps”).</p>
        
        <p>It applies regardless of whether you use a computer, mobile phone, tablet, or television or any other media or computer resource to access our platforms. It also applies to those who register on our platforms in connection with the use of our services. It is important that you read the Privacy Policy carefully because whenever you use our platforms, your personal data may be processed in accordance with this policy.</p>
        
        <p>This Policy forms part and parcel of the ‘Terms of Use’ as relevant for the Apps and Website services (“Apps and Website Services”). India Shelter is committed to abide by all laws in force within the territory of India including provisions of the Information Technology Act, 2000, principles of Digital Personal Data Protection Act, 2023 and the Aadhaar (Targeted Delivery of Financial and other Subsidies, benefits and services) Act, 2016.</p>
        <br/>
        <h6>Information Collection</h6>
        <p>The Company respects the privacy of the users of the Apps and Website/portal Services and is committed to reasonably protect it in all respects. The information about the user as collected by the Company is:</p>
        <ul style={{marginLeft:'2vw'}}>
            a) Information supplied by users on the Apps and / or the Website, as the case may be <br/>
            b) Information automatically tracked while using our Apps and Website Services.
        </ul>
        <br/>
        <h6>Mandatory Registration for Apps</h6>
        <p>It is mandatory to register yourself in order to use the App. We indicate which fields are mandatory and which are optional. You would be given an option to accept or decline the terms of this Policy. We will not be able to register you if you are not in agreement with the terms of this Policy.</p>
        
        <p>It is clarified that registration is not mandatory for using the Website. If you access and use the Website, you would be deemed to give your consent for collection, storage, and use of Personal Information in terms of the provisions of this Policy.</p>
        <br/>
        <h6>Collection of Personal Information</h6>
        <p>When you register for our apps and / or use our Apps, we collect and store your personal information such as, but not limited to, your name, demographics, behavior patterns, financial transaction details (excluding any Debit Card/Credit Card/third party user credentials details) and/or such other information as may be provided by you from time to time such as billing address, details of recipients, his or her location, etc. on the website and / or App (“Personal Information”).</p>
        <br/>
        <h6>Personal Data we Collect from the Website</h6>
        <p>Following data points are collected by our website:</p>
        <ul style={{marginLeft:'2vw'}}>
            <li>Name</li>
            <li>Phone/mobile</li>
            <li>Email ID</li>
            <li>Address (City, State, Pin code)</li>
            <li>PAN Card</li>
            <li>Google Analytics data</li>
            <li>IP Address</li>
        </ul>
        <br/>
        <h6>Cookies</h6>
        <p>We use data collection software tools such as ‘Cookies’ on certain pages of our Apps and Website to help analyze page flow, measure promotional effectiveness, and promote trust and safety in relation to the Apps and Website. ‘Cookies’ are small files placed on your device hard-drive/storage that assist us in providing our App and Website Services.</p>
        <br/>
        <h6>Use of Personal Data</h6>
        <p>We process your personal data as per principles of purpose limitation, storage limitation, data minimization and fair, transparent and lawful processing. Our objectives being:</p>
        <ul style={{marginLeft:'2vw'}}>
            <li>To provide you with our services and products and in the course of provision, we may share your information with third-party agents/contractors we may appoint.</li>
            <li>To improve your user experience and the overall quality of our services.</li>
            <li>To send you updates on promotional/special offers, products, services, news and events from us or our associate(s)/partner(s).</li>
            <li>To communicate with you concerning our service.</li>
            <li>To improve our platforms and content thereon to provide better features and services.</li>
            <li>To conduct market research and surveys.</li>
            <li>To prevent, detect, investigate, and act against crimes.</li>
            <li>To establish, exercise, or defend legal rights in connection with legal proceedings.</li>
            <li>To help advertisers understand our audiences.</li>
            <li>To notify you about changes in terms of service or privacy policy.</li>
            <li>To provide you with customer support.</li>
        </ul>
        <br/>
        <h6>Information Sharing and Disclosure</h6>
        <p>We restrict access to your information to our employees who we believe reasonably need to know that information in order to fulfill their jobs. India Shelter does not rent, sell, or share Personal Data about you with other people or non-affiliated companies except:</p>
        <ul style={{marginLeft:'2vw'}}>
            <li>a) to provide products or services you've requested,</li>
            <li>b) when India Shelter has your permission,</li>
            <li>c) or under specific circumstances as outlined in our policy.</li>
        </ul>
        <br/>
        <h6>Links to Other Platforms</h6>
        <p>Our Apps and/or Website may be linked to other platforms that may collect personally identifiable information about you. The Company is not responsible for the privacy practices or the content of those linked platforms.</p>
        <br/>
        <h6>Security Precautions</h6>
        <p>Our Apps and Website has stringent security measures in place to protect the loss, misuse, and alteration of your Personal Information under our control. We adhere to strict security guidelines, protecting it against unauthorized access.</p>
        <br/>
        <h6>Consent (Applicable Only for Apps)</h6>
        <p>Your consent will be obtained at the time of mandatory registration process, which consent shall remain valid until withdrawn by you. You may provide your consent through a click on the tab ‘I Agree’ that would be displayed on your screen prior to usage of such Apps by you.</p>
        <br/>
        <h6>Changes to this Privacy Policy</h6>
        <p>We reserve the right to change or update this Privacy Policy or any other of our policies/practices at any time without giving any prior notification; hence, you are requested to review the Privacy Policy periodically.</p>
        <br/>
        <h6>Grievance Redressal</h6>
        <p>If you have any questions about this Privacy Policy, please contact our Data Protection Officer whose details are mentioned below:</p>
        <p><strong>Name of Grievance Officer:</strong> Mr. Rohit Gaur</p>
        <p><strong>Phone Number:</strong> 0124-4131822</p>
        <p><strong>Email Id:</strong> rohit.gaur@indiashelter.in</p>
        <p><strong>Name of Data Protection Officer:</strong> Mr. Dheeraj Yadav</p>
        <p><strong>Phone Number:</strong> 0124-4131800</p>
        <p><strong>Email Id:</strong> dheeraj.yadav@indiashelter.in</p>
        <br/>
        <h6>Disclaimer</h6>
        <p>We do not store any bank account related information or any credit/debit card details. We shall not be liable for any loss or damage sustained by Users as a result of any disclosure of any information concerning the User's account.</p>
        <br/>
        <h6>Children’s Privacy</h6>
        <p>These Services do not address anyone under the age of 18. We do not knowingly collect personally identifiable information from children under 18.</p>
        <br/>
        <h6>Transfer of Identity Information Outside India</h6>
        <p>INDIA SHELTER FINANCE CORPORATION LIMITED shall not host or transfer identity information outside the territory of India in compliance with the Aadhaar Act and its Regulations.</p>
        <br/>
        <h6>Privacy by Design</h6>
        <p>INDIA SHELTER FINANCE CORPORATION LIMITED shall establish processes to embed privacy aspects at the design stage of any new systems, products, processes, and technologies involving data processing of identity information of Aadhaar number holders.</p>
        <br/>
        <h6>Governance and Accountability Obligations</h6>
        <p>A Privacy committee shall be established to provide strategic direction on privacy matters. A person (Privacy Officer or Data Protection Officer) responsible for developing, implementing, maintaining, and monitoring the comprehensive, organization-wide governance and accountability shall be designated to ensure compliance with the applicable laws.</p>
        <br/>
        <h6>Grievance Redressal Mechanism</h6>
        <p>Aadhaar number holders with grievances about the processing can contact the Privacy Officer via multiple channels like on the website, through phone, SMS, mobile application, etc. Reasonable measures shall be taken to inform the residents/customers/individuals about the Privacy Officer and his contact details.</p>
        <br/>
        <h6>Responsibility for Implementation and Enforcement of the Policy</h6>
        <p>The overall responsibility of monitoring and enforcement of this policy through various mechanisms such as audits shall be with the Privacy Officer. Responsibility for the implementation of controls of this policy shall also be with the Privacy Officer.</p>
        <br/>
        <h6>Relevant Provisions of Aadhaar Act and Supreme Court Judgement</h6>
        <p>INDIA SHELTER FINANCE CORPORATION LIMITED shall refer to the following relevant documents for ensuring compliance with the Aadhaar requirements:</p>
        <ul style={{marginLeft:'2vw'}}>
            <li>Judgement of Honorable Supreme Court dated September 2018</li>
            <li>Aadhaar Act 2016</li>
            <li>Aadhaar and Other Laws (Amendment) Act 2019</li>
            <li>Aadhaar (Authentication) Regulations 2016</li>
            <li>Aadhaar (Data Security) Regulations 2016</li>
            <li>Aadhaar (Sharing of Information) Regulations 2016</li>
        </ul>
          </div>
        </div>
       <LayoutShortcut/>
      </>
    );
}}
 
 
 